import axios from 'axios';

const newTokenizer = process.env.URL_TOKENIZER;

export const getToken = async () => {
    const data = await axios.post(
        `${newTokenizer}`,
        {'action': 'getJWT'},
        {
            headers: {
                Apikey: process.env.URL_TOKENIZER_APIKEY,
                Origin: process.env.URL_TOKENIZER_ORIGIN,
                "Content-Type": "application/json",
            },
        }
    );
    return data;
};